import { Component, OnInit, ViewChild } from '@angular/core';
import gql from 'graphql-tag';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ParametroEmpresaService } from 'src/app/services/parametro-empresa.service';
import { UnidadNegocioService } from 'src/app/services/unidad-negocio.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { FacturaManualCabeceraComponent } from './factura-manual-cabecera/factura-manual-cabecera.component';
import { FacturaManualDetallesComponent } from './factura-manual-detalles/factura-manual-detalles.component';

@Component({
  selector: 'app-factura-manual',
  templateUrl: './factura-manual.component.html',
  styleUrls: ['./factura-manual.component.scss'],
  providers: [SecurityService],
})
export class FacturaManualComponent implements OnInit {
  @ViewChild(FacturaManualCabeceraComponent, { static: true }) cabeceraComponent: FacturaManualCabeceraComponent;
  @ViewChild(FacturaManualDetallesComponent, { static: true }) detallesComponent: FacturaManualDetallesComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  private rutUsuario: number;

  public permiteUnidadNegocio: boolean = false;
  public validarDetalle: boolean = false;
  optionsUnidadesDeNegocio: unidad_negocio[] = [];

  // CODIGOS DTE PARA EL COMPONENTE VIEW FOLIOS
  codigos_dte: number[];

  // COUNT PARA LAS FACTURAS REALIZADAS
  contadorFacturas: number = 0;

  processing: boolean = false;

  // Utils
  private log: any;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private toastService: ToastService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private rutService: RutService,
    private parametroEmpresaService: ParametroEmpresaService,
    private unidadNegocioService: UnidadNegocioService
  ) {
    this.codigos_dte = [33, 34];
    this.log = this.clog.log('MAIN');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.parametroUnidadNegocio();
    this.loadUnidadNegocio();
  }

  parametroUnidadNegocio() {
    this.parametroEmpresaService.permiteUnidadNegocio(this.rutEmpresa, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.permiteUnidadNegocio = respuesta.valor_bool;
    });
  }

  loadUnidadNegocio() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        tipo: 1,
      },
    };
    this.optionsUnidadesDeNegocio = [];
    this.unidadNegocioService.obtenerUnidadNegocio(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsUnidadesDeNegocio = registros.map((unidad_negocio) => ({
        value: unidad_negocio.codigo,
        label: unidad_negocio.nombre,
      }));
    });
  }

  handleClienteChange(cliente) {
    this.detallesComponent.handleClienteChange(cliente);
  }

  onAddProduct(tipo) {
    const headerData = this.cabeceraComponent.getHeaderData();

    // const { sucursal } = headerData
    // if (sucursal.condicion_pago_codigo === 0 || sucursal.condicion_pago_codigo === '0') {
    //   this.toastrService.error('Sucursal seleccionada no tiene condición de pago especificada')
    //   return
    // }

    switch (tipo) {
      case 'LIBRE':
        this.detallesComponent.agregarProductoLibre(headerData);
        break;
      case 'NO_FACTURABLE':
        this.detallesComponent.agregarProductoNoFacturable(headerData);
        break;
      case 'NORMAL':
        this.detallesComponent.agregarProducto(headerData);
        break;
      default:
        break;
    }
  }

  onProductAdded(tipo: 'LIBRE' | 'NO_FACTURABLE' | 'NORMAL') {
    this.cabeceraComponent.disableHeader(tipo);
  }

  guardar() {
    if (!this.cabeceraComponent.validate()) {
      this.toastService.warning('Favor complete los datos requeridos');
      return;
    }
    // this.validateAllFormFields(this.formHeader);
    // if (!this.formHeader.valid) {
    //   this.toastrService.warning('Favor complete los datos requeridos');
    //   return
    // }

    const headerData = this.cabeceraComponent.getHeaderData();
    const detailsData = this.detallesComponent.getDetailsData();

    this.log('header data', headerData);
    this.log('details data', detailsData);

    if (!headerData) {
      this.toastService.warning('Favor complete los datos requeridos');
      return;
    }

    if (!headerData.cliente) {
      this.toastService.warning('Favor ingrese cliente');
      return;
    }

    if (!headerData.fechaFactura) {
      this.toastService.warning('Favor ingrese fecha documento');
      return;
    }

    if (!headerData.sucursal) {
      this.toastService.warning('Favor ingrese sucursal');
      return;
    }

    if (!headerData.vendedor) {
      this.toastService.warning('Favor ingrese vendedor');
      return;
    }

    if (!detailsData || !detailsData.detalleDocumento || detailsData.detalleDocumento.length === 0) {
      this.toastService.warning('Favor ingrese detalles');
      return;
    }

    detailsData.detalleDocumento.forEach((detalle) => {
      if (detalle.cantidad === 0 || detalle.cantidad === '' || detalle.cantidad === null) {
        this.validarDetalle = true;
        this.toastService.warning('Favor ingrese  cantidad valida detalles al producto ', detalle.descripcion_producto);
        return;
      }
    });

    if (this.validarDetalle === true) {
      return;
    }

    const { cliente, sucursal, condicionPago, vendedor, tipo_dte_codigo, detailRef } = headerData;
    const { detalleDocumento, totalesDocumento } = detailsData;

    detailRef.map((x) => {
      delete x.checked;
      delete x.index;
    });

    let { descuentosGlobales } = headerData;
    if (descuentosGlobales[0].monto_descuento === 0 && descuentosGlobales[1].monto_descuento === 0) descuentosGlobales = [];

    this.log('header data', headerData);
    this.log('details data', detailsData);
    // const fechaVencimiento = format(new Date(headerData.fechaVencimiento), 'yyyy-MM-dd')
    // if (sucursal.condicion_pago_codigo === 0 || sucursal.condicion_pago_codigo === '0') {
    //   this.toastrService.error('Sucursal seleccionada no tiene condición de pago especificada')
    //   return
    // }


    const tieneMovil = sucursal.fono_movil != '' && sucursal.fono_movil != null && sucursal.fono_movil != 0;
    const tieneFonoFijo = sucursal.fono_fijo != '' && sucursal.fono_fijo != null && sucursal.fono_fijo != 0;
    let fono = tieneMovil ? sucursal.fono_movil : tieneFonoFijo ? sucursal.fono_fijo : 0;

    let entidad = {
      cabecera: {
        rut_emisor: this.rutEmpresa,
        // tipo_dte_codigo: headerData.facturaAfecta ? 33 : 34, // AFECTA:33, EXCENTA:34
        tipo_dte_codigo,
        unidad_negocio_codigo: headerData.unidad_negocio_codigo,
        cliente_proveedor_rut: cliente.rut,
        condicion_pago_codigo: condicionPago,
        sucursal_codigo: this.sucursalEmpresa,
        vendedor_codigo: vendedor.codigo,
        vendedor_nombre: vendedor.nombre,
        fecha_emision: headerData.fechaFactura,
        rut_receptor: cliente.rut,
        giro_cliente: cliente.giro,
        fono_cliente: String(fono),

        direccion_completa_facturacion: sucursal.direccion_completa,
        comuna_facturacion: sucursal.nombreComuna,
        provincia_facturacion: sucursal.nombreProvincia,
        region_facturacion: sucursal.nombreRegion,

        // TODO: Seleccionar valores dependiendo de usa_direccion_despacho
        direccion_completa_despacho: sucursal.usa_direccion_despacho ? sucursal.direccion_completa : sucursal.direccion_completa,
        comuna_despacho: sucursal.usa_direccion_despacho ? sucursal.nombreComuna : sucursal.nombreComuna,
        princia_despacho: sucursal.usa_direccion_despacho ? sucursal.nombreProvincia : sucursal.nombreProvincia,
        region_despacho: sucursal.usa_direccion_despacho ? sucursal.nombreRegion : sucursal.nombreRegion,

        // giro_cliente: "", // Está correcto?
        // fono_cliente: "", // Está correcto?
        monto_descuento: totalesDocumento.descuento,
        monto_recargo: totalesDocumento.recargo,
        subtotal_neto: totalesDocumento.subtotal,
        monto_total_neto: totalesDocumento.neto,
        monto_iva: totalesDocumento.iva,
        monto_afecto: totalesDocumento.afecto, // TODO: PINTAR EN EL FRONT
        monto_exento: totalesDocumento.exento,
        subtotal: totalesDocumento.subtotal,
        monto_total: totalesDocumento.total,

        nota_venta: '', // FIJO
        orden_compra: '', // FIJO
        aplica_rebaja: true, // FIJO
        aplica_recorrido: headerData.incluirEnRecorrido,
        observaciones: '',
        ticket_sii: 0, // FIJO
        fecha_vencimiento: headerData.fechaVencimiento,
        id_lsoft: 0, // FIJO
        motivo_devolucion_codigo: 0, // FIJO
        tipo_despacho_codigo: 0, // FIJO
        centro_costo_codigo: '', // FIJO
        forma_pago_codigo: 1, // FIJO
        tipo_destinatario_codigo: 0, // FIJO
        es_entrega_gratuita: false, // FIJO
        direccion_codigo: sucursal.codigo,
        usuario_rut_usuario: this.rutUsuario, // me falta
        lista_precio_codigo: cliente.lista_precio_codigo, // me falta
      },
      detalleReferencia: detailRef,
      // descuentosGlobales: [],
      descuentosGlobales,
      detalleDocumento,
    };

    this.log(JSON.stringify(entidad));

    // return

    const self = this;

    self.processing = true;
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: documentoDTOInputType) {
            documento {
              guardarDTO(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    cliente_proveedor_rut
                    tipo_envio_codigo
                  }
                }
              }
            }
          }
        `,
        variables: {
          entidad: entidad,
        },
      },
      function (_respuesta) {
        const { mensajes, respuesta } = _respuesta.data.documento.guardarDTO;
        const ok = respuesta !== null;
        if (!ok) {
          self.messageRendererService.showErrors(mensajes);
          self.processing = false;
          return;
        } else {
          const folio = respuesta.cabecera.folio.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          self.toastService.success(`Factura nro: ${folio} creada.`);
          self.clearContents();
          self.processing = false;
          self.contadorFacturas++;
          return;
        }
      }
    );
  }

  clearContents() {
    this.cabeceraComponent.clearContent();
    this.detallesComponent.clearContents();
  }

  clearFromButton() {
    this.modalConfirm.show(() => {
      this.clearContents();
    });
  }

  beginSave() {
    this.guardar();
  }
}
